export * from '@libraries/typescript/utilities/assert';
export * from '@libraries/typescript/utilities/shift_identity';
export * from '@libraries/typescript/utilities/types';

export function noop() {}

/**
 * Simple UUID v4 implementation that can be used when cryptographic security
 * or strong randomness are not required.
 */
export function generateUuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
